import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import CancelModal from "../../../../shared/components/CancelModal";
import { WarningProductModal } from "../../../../configs/warningProductModal";
import { CreateSupplementTitleBar } from "../../../../configs/supplement";

interface TitleProps {
    title: string;
    setValidated: Function;
    submitForm: Function;
    isLoading?: boolean;
}

const Title = ({ title, setValidated, submitForm, isLoading = false }: TitleProps) => {
    const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
    const navigate = useNavigate();

    const titleActions: TitleAction[] = [
        {
            title: CreateSupplementTitleBar.cancelButton,
            onClick: () => setIsOpenCancelModal(true),
        },
        {
            title: CreateSupplementTitleBar.addButton,
            variant: "contained",
            isLoading,
            onClick: () => {
                if (isLoading) return;
                setValidated(true);
                submitForm();
            },
        },
    ];

    return (
        <>
            <TitleRow title={title} actions={titleActions} />
            {isOpenCancelModal && (
                <CancelModal
                    open={isOpenCancelModal}
                    title={WarningProductModal.title}
                    contentText={WarningProductModal.context}
                    handleConfirm={() => navigate("/extrafees/")}
                    handleClose={() => setIsOpenCancelModal(false)}
                />
            )}
        </>
    );
};

export default Title;
